<template>
  <vx-card>
    <vs-input
      class="w-full mb-4"
      label="Тема заявки"
      v-model="newRequest.theme"
    />

    <vs-input
      class="w-full mb-4"
      label="Сообщение заявки"
      v-model="newRequest.body"
    />

    <label class="vs-input--label">Житель</label>
    <v-select
      v-if="users !== null"
      label="name"
      :options="users"
      :reduce="(name) => name.id"
      :clearable="false"
      class="mb-4"
      v-model="newRequest.user"
    >
      <div slot="no-options">Совпадений не найдено</div>
    </v-select>

    <vs-button
      @click="createRequest"
      :disabled="!validateForm"
      class="mr-5"
      ref="loadableButton"
      type="relief"
      vslor="primary"
    >
      Создать
    </vs-button>
  </vx-card>
</template>

<script>
export default {
  data: () => ({
    newRequest: {
      theme: "",
      body: "",
      user: 0,
    },
    users: null,
  }),
  components: {},
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.newRequest.theme !== "" &&
        this.newRequest.body !== "" &&
        this.newRequest.user !== 0
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getAllusers() {
      this.$vs.loading();
      this.users = [];

      this.$load(async () => {
        let res = (await this.$api.users.getUsers()).data;

        res.forEach((user) => {
          if (!user.in_consideration && user.is_confirmed) {
            let countyName =
              user.homes[0].county_type == "forest" ? "ГЛ" : "ГП";
            let userData = {
              id: user.id,
              name: `${user.full_name} | ${countyName}, ${user.homes[0].homestead_number}`,
            };
            this.users.push(userData);
          }
        });

        this.$vs.loading.close();
      });
    },
    createRequest() {
      try {
        this.$load(async () => {
          let res = await this.$api.support.createTicket(this.newRequest);

          this.notification("Успешно", "Заявка создана", "success");

          this.$router.push({ name: "requests" });
        });
      } catch (err) {
        this.notification("Ошибка", "Не удалось создать заявку", "danger");
      }
    },
  },
  created() {},
  mounted() {
    this.getAllusers();
  },
};
</script>